import React from 'react';
import styled from 'styled-components';

import { IApplication } from '../../models';

const Card = styled.div`
    display: flex-wrap;
    border-width: 2px;
    margin: 10px;
    padding: 13px 16px;
    width: 150px;
    color: black;
    background-color: white;
    border-color: #eeeeee;
    border-style: solid;
    justify-content: center;
    align-items: center;
    text-align: center;
    transition: background-color 0.2s ease, color 0.2s ease;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    :hover {
        cursor: pointer;
        background-color: #FF7203;
        color: white;
    }

    :focus {
        background-color: #FF7203;
        color: white;
        outline: none;
    }`;

const Text = styled.span`
    display: flex;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Arial, Helvetica, sans-serif;
    height: 100%;
`;

interface IProps {
  application: IApplication;
  onClick: (application: IApplication) => void;
}

const ApplicationCard: React.FC<IProps> = ({ application, onClick }) => (
  <Card tabIndex={0} onClick={() => onClick(application)}>
    <Text>{application.name}</Text>
  </Card>
);

export default ApplicationCard;
